import styled from 'styled-components'

const StyledLinks = styled.div`
  .link-grid {
    display: grid;
    grid-gap: 32px;
    align-items: start;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }
`

export default StyledLinks
